import { render } from "./WorkspacePage.vue?vue&type=template&id=9fd70cd0&scoped=true"
import script from "./WorkspacePage.vue?vue&type=script&lang=js"
export * from "./WorkspacePage.vue?vue&type=script&lang=js"

import "./WorkspacePage.vue?vue&type=style&index=0&id=9fd70cd0&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd70cd0"]])

export default __exports__